import { z } from 'zod';
export const accountCreateSchema = z.object({
    project_id: z.string().uuid(),
    name: z.string().min(1).max(500),
    website: z.string().max(500).optional().nullable(),
    industry: z.string().max(200).optional().nullable(),
    company_size: z.string().max(100).optional().nullable(),
    parent_account_id: z.string().uuid().optional().nullable(),
    notes: z.string().max(10000).optional().nullable(),
});
export const accountUpdateSchema = accountCreateSchema.partial().omit({ project_id: true });
export const accountsListQuerySchema = z.object({
    project_id: z.string().uuid(),
    q: z.string().max(200).optional(),
});
export const accountsAutocompleteQuerySchema = z.object({
    project_id: z.string().uuid(),
    q: z.string().min(3).max(200),
});
//# sourceMappingURL=account.js.map